import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // App state (no user auth needed)
  },
  mutations: {},
  actions: {},
  getters: {},
});

export default store;
